query CompanyCurrencies($filter: CompanyCurrencyFilter) {
  companyCurrencies(orderBy: ISO_CODE_ASC, filter: $filter) {
    nodes {
      id
      name
      isoCode
    }
  }
}
